__turbopack_context__.v({
  "feature-card": "FeatureCards-module-scss-module__O7Ng9W__feature-card",
  "feature-card__body": "FeatureCards-module-scss-module__O7Ng9W__feature-card__body",
  "feature-card__copy": "FeatureCards-module-scss-module__O7Ng9W__feature-card__copy",
  "feature-card__cta": "FeatureCards-module-scss-module__O7Ng9W__feature-card__cta",
  "feature-card__eyebrow": "FeatureCards-module-scss-module__O7Ng9W__feature-card__eyebrow",
  "feature-card__heading": "FeatureCards-module-scss-module__O7Ng9W__feature-card__heading",
  "feature-card__image": "FeatureCards-module-scss-module__O7Ng9W__feature-card__image",
  "feature-card__media": "FeatureCards-module-scss-module__O7Ng9W__feature-card__media",
  "feature-cards": "FeatureCards-module-scss-module__O7Ng9W__feature-cards",
  "feature-cards__grid": "FeatureCards-module-scss-module__O7Ng9W__feature-cards__grid",
});
